import "./App.css";

function App() {
  return (
    <div className="site">
      {/* All components hidden
      <nav className="nav">
        <div className="nav-inner">
          <a href="#" className="nav-logo" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}>
            Stone Crop River
          </a>
          <div className="nav-links">
            <a href="#work">Work</a>
            <a href="#about">About</a>
            <a href="#contact">Contact</a>
          </div>
        </div>
      </nav>

      <section className="hero section">
        <h1 className="hero-title">The Living Software Company</h1>
        <p className="hero-subtitle">
          Hospitable spaces in a hostile digital landscape. We build software
          that nurtures rather than extracts&mdash;tools shaped by the people
          who use them, not the other way around.
        </p>
      </section>

      <div className="section-divider">
        <hr />
      </div>

      <section id="work" className="products section">
        <span className="section-label">Work</span>

        <div className="product-card">
          <div className="product-header">
            <h2 className="product-name">Space Time</h2>
            <p className="product-desc">
              A space for your time. Not another productivity tool
              competing for your attention&mdash;a quiet container for plans,
              tasks, and days that gains meaning through use.
            </p>
          </div>
          <div className="product-gallery">
            <div className="device-frame">
              <img src={spacetimeTasks} alt="Space Time tasks view" />
            </div>
            <div className="device-frame">
              <img src={spacetimeHome} alt="Space Time home view" />
            </div>
          </div>
        </div>

        <div className="product-card">
          <div className="product-header">
            <h2 className="product-name">Finance Tracker</h2>
            <p className="product-desc">
              Your money, reflected back to you. A mirror for spending
              habits&mdash;no judgments, no gamification. Just clarity about
              where things go.
            </p>
          </div>
          <div className="product-gallery">
            <div className="device-frame">
              <img src={financeItem} alt="Finance Tracker item entry" />
            </div>
            <div className="device-frame">
              <img src={financeCoffee} alt="Finance Tracker coffee entry" />
            </div>
          </div>
        </div>
      </section>

      <div className="section-divider">
        <hr />
      </div>

      <section id="about" className="about section">
        <span className="section-label">About</span>
        <div className="about-content">
          <h2 className="about-heading">
            Software studio. Toronto.
          </h2>
          <p className="about-text">
            Most digital spaces are built to extract&mdash;your attention is
            currency, your engagement is liquidity. We build the opposite.
            Spaces that act as mirrors, not megaphones. Tools that gain meaning
            through use, not tools that impose it.
          </p>
          <p className="about-text">
            We design, build, and ship from 0&rarr;1. Mobile apps, product
            thinking, interfaces that feel like they belong to the person using
            them. We carry ideas across disciplines because the best work lives
            at the edges.
          </p>
          <div className="about-services">
            <div className="service-item">Mobile Development</div>
            <div className="service-item">Interface Design</div>
            <div className="service-item">Product Strategy</div>
            <div className="service-item">World Building</div>
          </div>
          <blockquote className="about-quote">
            Amidst the inhospitable terrain where nothing else endures, a single
            plant prospers by a lively riverbank.
          </blockquote>
        </div>
      </section>

      <div className="section-divider">
        <hr />
      </div>

      <section id="contact" className="contact section">
        <span className="section-label">Contact</span>
        <div className="contact-grid">
          <div className="contact-group">
            <h3>Email</h3>
            <a href="mailto:contact@stonecropriver.com">
              contact@stonecropriver.com
            </a>
          </div>
          <div className="contact-group">
            <h3>Social</h3>
            <a
              href="https://x.com/stonecropriver"
              target="_blank"
              rel="noopener noreferrer"
            >
              X (Twitter)
            </a>
            <a
              href="https://www.instagram.com/stonecropriver/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>
          </div>
          <div className="contact-group">
            <h3>Address</h3>
            <p>
              2 Clarendon Ave
              <br />
              Toronto, ON M4V 1H9
            </p>
          </div>
        </div>
      </section>

      <footer className="site-footer">
        <div className="section">
          <p className="footer-copy">
            &copy; 2026 Stone Crop River. All rights reserved.
          </p>
          <div className="footer-links">
            <a href="#work">Work</a>
            <a href="#about">About</a>
            <a href="#contact">Contact</a>
            <a href="/privacy.html">Privacy</a>
          </div>
        </div>
      </footer>
      */}
    </div>
  );
}

export default App;
